import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import TeamCard from './TeamCard';
import { Markdown, Button } from '../elements';

const Section = styled.section`
  background: ${(props) => props.theme.darkShades};
  .card {
    border: 3px solid ${(props) => props.theme.borderColor};
  }
  .content h1,
  .content h2,
  .content h3,
  .content h4,
  .content h5,
  .content h6 {
    color: ${(props) => props.theme.textColorLite} !important;
    font-weight: 700;
  }
`;

const Team = ({ heading, buttonLink, teamList = [] }) => {
  return (
    <Section className="section is-medium">
      <div className="container">
        {heading && (
          <Markdown className="pb-2 has-text-white mb-5">{heading}</Markdown>
        )}

        <div className="columns is-multiline">
          {teamList &&
            teamList.map((item) => {
              if (!item) {
                return null;
              }
              return <TeamCard data={item} key={item._key} />;
            })}
        </div>
        {buttonLink && buttonLink.current && (
          <Link to={`/${buttonLink.current}/`}>
            <Button
              fullWidth
              className="is-uppercase is-size-4 has-text-white mt-5"
            >
              Request a Callback
            </Button>
          </Link>
        )}
      </div>
    </Section>
  );
};

export default Team;
